// store/UserStore.ts
import { create } from "zustand";



export interface IUser {
  id: string;
  fullName: string;
  username: string;
  userRole: "admin" | "supervisor" | "employee";
  employeeType?: "Karigar" | "Master" | "job-work" | "Group Work" | null;
  permissions: { 
    designMaster: boolean;
    vendorMaster: boolean;
    sizeMaster: boolean;
    fabricMaster: boolean;
    astarMaster: boolean;
    orderManagement: boolean;
    userAdmin: boolean;
  };

}

interface UserState {
  user: IUser | null;
  setUser: (user: IUser) => void;
  clearUser: () => void;   
  logout: () => void;   
 
}

export const useUserStore = create<UserState>((set) => ({
  user: null,

  setUser: (user) => set({ user }),

  clearUser: () => set({ user: null }),

  logout: () => {
   
    set({ user: null });

  
    localStorage.removeItem("token");
  },
}));
